<template>
  <v-dialog :value="value" max-width="400px" @input="$emit('input', $event)">
    <v-card>
      <v-card-title>Confirm Delete</v-card-title>
      <v-card-text>Are you sure you want to delete <strong>{{ target && (target.name || target.family) }}</strong>?</v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="$emit('input', false)">Cancel</v-btn>
        <v-btn color="error" :loading="deleting" @click="execute">Delete</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { apiService } from '../../service/api.service'

export default {
  name: 'JetsonDeleteDialog',
  props: {
    value: { type: Boolean, default: false },
    target: { type: Object, default: null },
    type: { type: String, default: '' }
  },
  data () {
    return { deleting: false }
  },
  methods: {
    async execute () {
      this.deleting = true
      try {
        if (this.type === 'device') {
          await apiService.delete(`admin/llm_models/jetson-devices/${this.target.id}`)
          this.$emit('deleted', { type: 'device', message: 'Device deleted' })
        } else {
          await apiService.delete(`admin/llm_models/jetson-model-arch/${this.target.id}`)
          this.$emit('deleted', { type: 'arch', message: 'Architecture deleted' })
        }
        this.$emit('input', false)
      } catch (e) {
        this.$emit('error', 'Delete failed')
      }
      this.deleting = false
    }
  }
}
</script>
